<div (window:resize)="readjustSize()" class="screen-element screen-menu" #screenElement>

	<div #titleElement [ngStyle]="{'opacity':titleopacity}" class="text title"
		[ngClass]="{'darkTitle':hasParameter('darkTitle'),'darkerTitle':hasParameter('darkerTitle')}">
		{{title|uppercase}}<span *ngIf="menuIcon" class="menu-icon inline-icon {{menuIcon}}">&nbsp;</span></div>
	<div #titleElement2 [ngStyle]="{'opacity':titleopacity,'white-space': 'pre-wrap','z-index':5}" class="subtitle"
		[ngClass]="{'subtitleAtBottom':hasParameter('subtitleAtBottom')}" class="text subtitle">{{subtitle}}</div>
	<div *ngIf="!hasParameter('noline')" class="marker"></div>

	<div #wrapElement [ngStyle]="{'top':top}"
		[ngClass]="{'transition-enabled': transitionalMovement(),'list':hasParameter('list') && underlined,'dashed':hasParameter('dashed') }"
		class="menu-elements-wrap">
		<ng-container *ngIf="!inline">
			<div *ngFor="let el of menuElements">
				<div class="menu-row-wrap">
					<div class="menu-row"
						[ngClass]="{'active':el==currentElement,'hidden_above':(isAboveMarker(el)&&hasParameter('hideElementsAboveMarker')), 'nobox':hasParameter('nobox'),'oneLineHeight':hasParameter('oneLineHeight')}">
						<div class="menu-item-wrap"
							[ngClass]="{'listItem':hasParameter('list'),'withMarker':hasParameter('showmarker'),'dashed':hasParameter('dashed')}">
							<div class="menu-item">
								<!--
										<span *ngIf="el.icon" class="icon inline-icon {{el.icon}}"></span>
										<span class="">{{el.getTitle()}}</span>
									-->
								<text-widget *ngIf="!delayed" [focused]="el == currentElement"
									[delayed]="el.hasParameter('loadDelay')" [color]="getColor(el)" [dashed]="dashed"
									[valueHidden]="loadValueOnSelect && !isUncovered(el)"
									[isListItem]="(hasParameter('list') || el.hasParameter('list'))"
									[underlined]="underlined" [text]="el.getTitle()"></text-widget>
								<text-widget *ngIf="delayed" [color]="getColor(el)" [dashed]="dashed"
									[valueHidden]="loadValueOnSelect && !isUncovered(el)"
									[isListItem]="hasParameter('list')" [underlined]="underlined"
									[text]="'---'"></text-widget>
							</div>
						</div>
					</div>
				</div>
				<div class="submenu-wrap" [ngClass]="{'open':isOpen(el)}">
					<div *ngFor="let subEl of el.getChilds()" class="submenu-row"
						[ngClass]="{'active':subEl==currentElement}">
						<div class="menu-item-wrap">
							<div class="menu-item">
								<span>{{subEl.getTitle()}}</span>
							</div>
						</div>
					</div>
				</div>
			</div>
		</ng-container>
		<ng-container *ngIf="inline && !delayed">
			<div>
				<div class="menu-row-wrap">
					<div class="menu-row active" [ngClass]="{'nobox':hasParameter('nobox')}">
						<div class="menu-item-wrap" [ngClass]="{'listItem':hasParameter('list')}">
							<div class="menu-item">
								<!--
										<span *ngIf="el.icon" class="icon inline-icon {{el.icon}}"></span>
										<span class="">{{el.getTitle()}}</span>
									-->
								<text-widget [color]="getColor(currentElement)" [isListItem]="hasParameter('list')"
									[underlined]="underlined" [text]="currentElement.getTitle()"></text-widget>
							</div>
						</div>
					</div>
				</div>
			</div>
		</ng-container>
		<ng-container *ngIf="inline && delayed">
			<div>
				<div class="menu-row-wrap">
					<div class="menu-row active" [ngClass]="{'nobox':hasParameter('nobox')}">
						<div class="menu-item-wrap" [ngClass]="{'listItem':hasParameter('list')}">
							<div class="menu-item">
								<!--
										<span *ngIf="el.icon" class="icon inline-icon {{el.icon}}"></span>
										<span class="">{{el.getTitle()}}</span>
									-->
								<text-widget [color]="getColor(currentElement)" [isListItem]="hasParameter('list')"
									[underlined]="underlined" [text]="'---'"></text-widget>
							</div>
						</div>
					</div>
				</div>
			</div>
		</ng-container>

	</div>
</div>